export const subscript2 = '\u2082';
export const superscript2 = '\u00B2';
